import { useEffect, useEffectEvent } from 'react';
import type { AutomationFailureNotification } from 'types/pushNotifications';
import { emitAutomationFailureRefresh } from './useAutomationFailureRefresh';

type AutomationFailureListener = (notification: AutomationFailureNotification) => void;

const notificationListeners = new Set<AutomationFailureListener>();

export const emitAutomationFailureNotification = (notification: AutomationFailureNotification) => {
  notificationListeners.forEach((listener) => listener(notification));
  emitAutomationFailureRefresh();
};

export const useAutomationFailureNotifications = (onNotification: AutomationFailureListener) => {
  const notify = useEffectEvent(onNotification);

  useEffect(() => {
    const listener = (notification: AutomationFailureNotification) => notify(notification);
    notificationListeners.add(listener);

    return () => {
      notificationListeners.delete(listener);
    };
  }, []);
};
